export const SET_QRCODE_SVG = 'SET_QRCODE_SVG';
export const CHANGE_LOADING_STATUS = 'CHANGE_LOADING_STATUS';
